import React from 'react';
/*import { ReactComponent as ErrorIcon } from 'assets/images/icon/form-check-error.svg';*/
interface IProps {
  label?: string;
  name?: string;
  id?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  readOnly?: boolean;
  checked?: boolean;
  error?: string;

  ref?: any;
}
const CustomCheck = (props: IProps) => {
  React.useEffect(() => {}, []);

  const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const syntheticEvent = {
      target: {
        name: props.name,
        value: e.target.checked,
        type: 'checkbox'
      }
    } as any;
    props.onChange?.(syntheticEvent);
  };

  return (
    <>
      <div className={`custom-check ${props.className || ''}`} style={props.style}>
        <label form={props.id}>
          <input
            id={props.id}
            name={props.name}
            type={'checkbox'}
            value={props.value}
            checked={props.checked}
            onChange={handleOnchange}
            disabled={props.disabled}
            readOnly={props.readOnly}
            ref={props?.ref}
          />
          <span>{props.label}</span>
        </label>

        {props.error && (
          <div className="error-text">
            {/*<ErrorIcon className="c-pointer" width={12} height={12} aria-label="close" role="img" />*/}
          </div>
        )}
      </div>
    </>
  );
};

export default CustomCheck;
